import {Route, Navigate} from "react-router-dom";
import {SentryRoutes} from "../../utils/sentryRoute";
import {DocumentTitle} from "../../atoms/document-title";
import {SftpConfigCreate, SftpConfigEdit, SubMenu} from "./atoms";
import {SftpConfigurations} from "./SftpConfigurations";
import {TemplateFields} from "./TemplateFields";
import {EventTriggers} from "./EventTriggers";
import {EventTriggerCreate} from "./EventTriggerCreate";
import {EventTriggerViewer} from "./EventTriggerViewer";
import {EventTriggerEdit} from "./EventTriggerEdit";
import {Layout} from "./styles";

export const HubAndSpokeRouter = () => (
  <>
    <DocumentTitle title="Reside - Admin - Hub & Spoke" />
    <Layout>
      <SubMenu />
      <SentryRoutes>
        <Route
          index
          element={
            <Navigate to="/admin/hub-and-spoke/sftp-configurations" replace />
          }
        />
        <Route path="sftp-configurations" element={<SftpConfigurations />} />
        <Route
          path="sftp-configurations/create"
          element={<SftpConfigCreate />}
        />
        <Route
          path="sftp-configurations/:sftpServerId/edit"
          element={<SftpConfigEdit />}
        />
        <Route path="template-fields" element={<TemplateFields />} />
        <Route path="event-triggers" element={<EventTriggers />} />
        <Route path="event-triggers/create" element={<EventTriggerCreate />} />
        <Route
          path="event-triggers/edit/:eventTriggerId"
          element={<EventTriggerEdit />}
        />
        <Route
          path="event-triggers/:eventTriggerId"
          element={<EventTriggerViewer />}
        />
      </SentryRoutes>
    </Layout>
  </>
);
